import * as React from 'react'
import {
  SectionWrapper,
  Container,
  TopRow,
  Profile,
  ProfileInfo,
  ProfileName,
  ProfileRole,
  Quote,
  StatsRow,
  StatCard,
  StatIcon,
} from './styled.components'
import Image from 'next/image'
import CoursesIllustration from './Svgs/CoursesIllustration'
import MarketingIllustration from './Svgs/MarketingIllustration'
import GlobeIllustration from './Svgs/GlobeIllustration'
import RatingIllustration from './Svgs/RatingIllustration'
import { useTranslation } from 'react-i18next'

const VisionSection: React.FC = () => {
  const { t } = useTranslation('about')
  return (
    <SectionWrapper>
      <Container>
        <TopRow>
          <Profile>
            <Image
              loading="lazy"
              src="/static/images/about/ceo.png"
              alt={t('vision.ceo.name')}
              className="object-cover object-top rounded-full size-[62px]"
              width={62}
              height={62}
            />
            <ProfileInfo>
              <ProfileName>{t('vision.ceo.name')}</ProfileName>
              <ProfileRole>{t('vision.ceo.role')}</ProfileRole>
            </ProfileInfo>
          </Profile>
          <Quote>
            <span className="hidden sm:inline">
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp;
            </span>
            ”{t('vision.quote')}”
          </Quote>
        </TopRow>
        <StatsRow>
          <StatCard>
            <StatIcon>
              <CoursesIllustration />
            </StatIcon>
            {t('vision.stats.courses.line1')}
            <br />
            {t('vision.stats.courses.line2')}
          </StatCard>
          <StatCard>
            <StatIcon>
              <MarketingIllustration />
            </StatIcon>
            {t('vision.stats.market.line1')}
            <br />
            {t('vision.stats.market.line2')}
          </StatCard>
          <StatCard>
            <StatIcon>
              <GlobeIllustration />
            </StatIcon>
            {t('vision.stats.countries.line1')}
            <br />
            {t('vision.stats.countries.line2')}
          </StatCard>
          <StatCard>
            <StatIcon>
              <RatingIllustration />
            </StatIcon>
            {t('vision.stats.rating.line1')}
            <br />
            {t('vision.stats.rating.line2')}
          </StatCard>
        </StatsRow>
      </Container>
    </SectionWrapper>
  )
}

export default VisionSection
